export default {"src":"/_next/static/media/how-arrow.5b6b71e4.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};